import React from 'react';
import { Text, StyleSheet } from 'react-native';
import { PAYMENT_DESIGN_TOKENS, PAYMENT_TYPOGRAPHY } from '@/constants/residents/mobile/paymentDesignTokens';
import { mobilePaymentsStrings } from '@/constants/residents/strings';
import { PaymentBottomSheet } from './PaymentBottomSheet';

interface PendingPaymentsModalProps {
  visible: boolean;
  onClose: () => void;
}

/**
 * Pending Payments Modal
 * Bottom sheet that explains pending payment status
 * Matches Figma design: "Payments pending pop up"
 */
export const PendingPaymentsModal: React.FC<PendingPaymentsModalProps> = ({
  visible,
  onClose,
}) => {
  return (
    <PaymentBottomSheet
      visible={visible}
      onClose={onClose}
      title={mobilePaymentsStrings.paymentsPending}
    >
      <Text style={styles.descriptionText}>
        {mobilePaymentsStrings.paymentsPendingMessage}
      </Text>
    </PaymentBottomSheet>
  );
};

const styles = StyleSheet.create({
  descriptionText: {
    ...PAYMENT_TYPOGRAPHY.bodySm,
    color: PAYMENT_DESIGN_TOKENS.TEXT_PRIMARY,
    lineHeight: 21,
  },
});
